import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { registerChangeClientListenerForTargetAccumulator } from '@/store/targetAccumulator/listeners/change-client-listener.ts';
import { registerDuplicateTargetAccumulatorTradeCaptureListeners } from '@/store/targetAccumulator/listeners/duplicate-listener.ts';
import { registerRfsTargetAccumulatorListeners } from '@/store/targetAccumulator/listeners/rfs-listener.ts';

export function registerTargetAccumulatorListeners(startAppListening: StartAppListening): void {
  registerChangeClientListenerForTargetAccumulator(startAppListening);
  registerDuplicateTargetAccumulatorTradeCaptureListeners(startAppListening);
  registerRfsTargetAccumulatorListeners(startAppListening);
}
